module.exports = __webpack_public_path__ + "img/edit-icon.f90ec0b2.svg";